/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MarketMapSettings} from '../models/MarketMapSettings';
import type {UserMarketMapSettingsSaveRequest} from '../models/UserMarketMapSettingsSaveRequest';

export interface GetUserMarketMapSettings$Request {
    userId: number;
}

export interface GetUserMarketMapSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserMarketMapSettingsRequest = createAction<PayloadData<void, GetUserMarketMapSettings$Request>>('USERS_MARKET_MAP_SETTINGS__GET_USER_MARKET_MAP_SETTINGS__REQUEST');
export const getUserMarketMapSettingsSuccess = createAction<PayloadData<MarketMapSettings, GetUserMarketMapSettings$Request>>('USERS_MARKET_MAP_SETTINGS__GET_USER_MARKET_MAP_SETTINGS__SUCCESS');
export const getUserMarketMapSettingsFailure = createAction<PayloadData<Error, GetUserMarketMapSettings$Request, true>>('USERS_MARKET_MAP_SETTINGS__GET_USER_MARKET_MAP_SETTINGS__FAILURE');

export const getUserMarketMapSettingsActions = [
    getUserMarketMapSettingsRequest,
    getUserMarketMapSettingsSuccess,
    getUserMarketMapSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserMarketMapSettings = (meta: GetUserMarketMapSettings$Request, config?: GetUserMarketMapSettings$Config) => {
    return {
        CALL_API: {
            types: getUserMarketMapSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/market-map-settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SetUserMarketMapSettings$Request {
    userId: number;
    userMarketMapSettingsSaveRequest: UserMarketMapSettingsSaveRequest;
}

export interface SetUserMarketMapSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const setUserMarketMapSettingsRequest = createAction<PayloadData<void, SetUserMarketMapSettings$Request>>('USERS_MARKET_MAP_SETTINGS__SET_USER_MARKET_MAP_SETTINGS__REQUEST');
export const setUserMarketMapSettingsSuccess = createAction<PayloadData<void, SetUserMarketMapSettings$Request>>('USERS_MARKET_MAP_SETTINGS__SET_USER_MARKET_MAP_SETTINGS__SUCCESS');
export const setUserMarketMapSettingsFailure = createAction<PayloadData<Error, SetUserMarketMapSettings$Request, true>>('USERS_MARKET_MAP_SETTINGS__SET_USER_MARKET_MAP_SETTINGS__FAILURE');

export const setUserMarketMapSettingsActions = [
    setUserMarketMapSettingsRequest,
    setUserMarketMapSettingsSuccess,
    setUserMarketMapSettingsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserMarketMapSettingsSaveRequest} meta.userMarketMapSettingsSaveRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const setUserMarketMapSettings = (meta: SetUserMarketMapSettings$Request, config?: SetUserMarketMapSettings$Config) => {
    return {
        CALL_API: {
            types: setUserMarketMapSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/market-map-settings`,
            TRANSPORT_REQUEST_BODY: meta.userMarketMapSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

